import React, { Component } from 'react';
import style from './header.scss';
import classes from 'cssClasses';

import {connect} from 'react-redux';


class Header extends Component{
	render() {
		return( 
				<nav className={classes("navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow")}>
		      <a className={classes("navbar-brand col-sm-3 col-md-2 mr-0")} href="/">
		      	<img className={classes("dashboard-brand",style)} src="https://www.h-farm.com/themes/custom/hfarm/img/logo.svg" alt="H-FARM" />
		      	H-Farm
		      </a>
		      {/*<input className={classes("form-control form-control-dark w-100")} type="text" placeholder="Search" aria-label="Search" />*/}
		      <ul className={classes("navbar-nav px-3",style)}>
		      	<li className={classes("nav-item text-nowrap")}>
		      		Ciao, { this.props.auth.googleProfile.displayName }
		      	</li>
		        <li className={classes("nav-item text-nowrap")}>
		          <a href="/api/logout" className={classes("nav-link")}>Sign out</a>
		        </li>
		      </ul>
		    </nav>
			);
	}
}


function mapStateToProp({auth}){
	return { auth }
}

export default connect(mapStateToProp)(Header);


// WEBPACK FOOTER //
// ./src/components/Backend/Layout/Header/Header.js